const useColumns = () => {
    return [
        { render: item => item?.title, colSpan: 4, id: 'title' },
        { render: item => item?.startDate, colSpan: 4, id: 'startDate' },
        { render: item => item?.endDate, colSpan: 4, id: 'endDate' },
        { render: item => item?.topicName, colSpan: 4, id: 'topicName' },
    ]
}

export default useColumns